<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading" class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              text
              @click="$router.push('/faturamento')"
              :disabled="loading"
              >Cancelar</v-btn
            >
            <v-btn
              text
              @click="salvarPromissorias"
              :loading="loading"
              :disabled="!form_valid"
            >
              Salvar
            </v-btn>
          </v-toolbar-items>
        </v-app-bar>
        <v-form>
          <v-container fluid v-if="pedido">
            <v-row dense>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Pedido"
                  v-model="pedido.id"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-if="pedido.cliente"
                  label="Cliente"
                  v-model="pedido.cliente.nome_fantasia"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-if="pedido.fornecedor"
                  label="Fornecedor"
                  v-model="pedido.fornecedor.nome_fantasia"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <as-campo-valor
                  label="Valor R$"
                  v-model="pedido.valor_liquido"
                  disabled
                ></as-campo-valor>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-divider></v-divider>
        <v-form ref="form" lazy-validation v-model="form_valid">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" sm="2">
                <as-date-picker-menu
                  ref="data"
                  label="Data"
                  :rules="rulesForm.data_inicio"
                  v-model="pedido.data"
                ></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="2">
                <as-date-picker-menu
                  ref="entrega"
                  label="Entrega"
                  :rules="rulesForm.data_inicio"
                  v-model="pedido.entrega"
                ></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="desconto"
                  label="Desconto %"
                  v-model="pedido.desconto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <as-campo-valor
                  ref="desconto_valor"
                  label="Desconto Valor"
                  v-model="pedido.desconto_valor"
                ></as-campo-valor>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="taxa"
                  label="Taxa"
                  v-model="pedido.taxa"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <as-campo-valor
                  ref="taxa"
                  label="Taxa Valor"
                  v-model="pedido.taxa_valor"
                ></as-campo-valor>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="frete"
                  label="Frete"
                  v-model="pedido.frete"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="frete_valor"
                  label="Frete Valor"
                  v-model="pedido.frete_valor"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-select
                  :items="tiposFrete"
                  label="Frete Tipo"
                  ref="frete_tipo"
                  v-model="pedido.frete_tipo"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="comissao"
                  label="Comissão %"
                  v-model="pedido.comissao"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <as-campo-valor
                  ref="comissao_valor"
                  label="Comissão Valor"
                  v-model="pedido.comissao_valor"
                ></as-campo-valor>
              </v-col>
              <v-col cols="12" sm="2">
                <v-select
                  :items="tiposComissao"
                  label="Comissão Tipo"
                  ref="comissao_tipo"
                  v-model="pedido.comissao_tipo"
                ></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="3">
                <v-select
                  :items="formaspagamento"
                  label="Forma Pagamento"
                  ref="forma_pagamento"
                  :rules="rulesForm.forma_pagamento"
                  v-model="pedido.forma_pagamento"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  ref="prazo"
                  label="Prazo"
                  v-model="pedido.prazo"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="vendedor"
                  label="Vendedor"
                  v-model="pedido.vendedor"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <as-campo-valor
                  ref="valor_bruto"
                  label="Valor Bruto"
                  v-model="pedido.valor_bruto"
                ></as-campo-valor>
              </v-col>
              <v-col cols="12" sm="2">
                <as-campo-valor
                  ref="valor_liquido"
                  label="Valor Líquido"
                  v-model="pedido.valor_liquido"
                ></as-campo-valor>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  type="number"
                  min="0"
                  max="24"
                  ref="pedido_parcelas"
                  label="Parcelas"
                  v-model="pedido.parcelas"
                  @input="gerarPromissorias"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  type="number"
                  ref="pedido_prazo"
                  label="Prazo"
                  v-model="pedido.prazo"
                  @input="gerarPromissorias"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>

      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Promissórias</v-toolbar-title>
        </v-app-bar>
        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="pedido.promissorias"
          hide-default-footer
          :loading="loading"
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.vencimento }}</td>
            <td>{{ props.item.dias }}</td>
            <td>{{ props.item.parcela }}</td>
            <td class="text-xs-right">{{ props.item.valor | valorBR }}</td>
          </template>
        </v-data-table>
      </v-card>
      <v-layout v-show="loading" justify-center align-center mt-5>
        <v-progress-circular
          indeterminate
          size="50"
          width="3"
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ServiceFaturamento from "../services/faturamento.js";
import { ptDateFormat } from "../util/dateFormat.js";
import moment from "moment";

export default {
  name: "FaturamentoForm",
  data() {
    return {
      loading: true,
      titulo: "Gerar Promissórias",
      exibirPesquisa: false,
      pesquisa: "",
      form_valid: true,
      tiposFrete: ["Cliente", "Fornecedor", "Ambos"],
      tiposComissao: ["Fornecedor"],
      formaspagamento: [
        "À Vista",
        "Depósito",
        "Transferência",
        "Cheque",
        "Cartão de Crédito",
        "Cartão de Débito",
        "Boleto",
        "PIX",
        "Duplicata",
      ],
      headers: [
        { text: "Vencimento", value: "vencimento", sortable: false },
        { text: "Dias", value: "dias", sortable: false },
        { text: "Parcela", value: "parcela", sortable: false },
        { text: "Valor", value: "valor", align: "right", sortable: false },
      ],
      pedido: {
        promissorias: [],
      },
      rulesForm: {
        data: [(value) => !!value || "Campo Obrigatório"],
        entrega: [(value) => !!value || "Campo Obrigatório"],
        forma_pagamento: [(value) => !!value || "Campo Obrigatório"],
        prazo: [(value) => !!value || "Campo Obrigatório"],
      },
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.abrir(this.$route.params.id);
    }
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async abrir(pedido) {
      try {
        this.loading = true;
        let response = await ServiceFaturamento.abrir(pedido);
        this.pedido = response.data.pedido;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    gerarPromissorias() {
      setTimeout(() => {
        if (
          this.pedido.parcelas &&
          this.pedido.prazo &&
          this.pedido.parcelas > "0" &&
          this.pedido.prazo > "0"
        ) {
          this.pedido.parcelas = parseInt(this.pedido.parcelas);
          this.pedido.prazo = parseInt(this.pedido.prazo);
          this.pedido.promissorias = [];

          let valor_parcela = parseInt(
            this.pedido.valor_liquido / this.pedido.parcelas
          );
          let diferenca_parcela =
            this.pedido.valor_liquido - valor_parcela * this.pedido.parcelas;
          let ultima_parcela = valor_parcela + diferenca_parcela;
          let hoje = this.pedido.data;

          for (let i = 1; i <= this.pedido.parcelas; i++) {
            let dias_add = this.pedido.prazo * i;
            let data_vencimento = moment(hoje, "YYYY-MM-DD").add(
              dias_add,
              "days"
            );

            if (data_vencimento.day() == 6) {
              // SE FOR SÁBADO
              data_vencimento.add(2, "days");
              dias_add = dias_add + 2;
            } else if (data_vencimento.day() == 0) {
              // SE FOR DOMINGO
              data_vencimento.add(1, "days");
              dias_add = dias_add + 1;
            }
            // console.log(
            //   data_vencimento.format('DD/MM/YYYY'),
            //   (i == this.pedido.parcelas) ? ultima_parcela : valor_parcela,
            //   i + '/' + this.pedido.parcelas
            //   )
            this.pedido.promissorias.push({
              vencimento: data_vencimento.format("DD/MM/YYYY"),
              valor: i == this.pedido.parcelas ? ultima_parcela : valor_parcela,
              dias: dias_add,
              parcela: i + "/" + this.pedido.parcelas,
            });
          }
        } else {
          this.pedido.promissorias = [];
        }
      }, 700);
    },
    async salvarPromissorias() {
      if (
        this.$refs.form.validate() &&
        this.pedido.promissorias &&
        this.pedido.promissorias.length > 0
      ) {
        try {
          this.loading = true;
          await ServiceFaturamento.salvarPromissorias(
            this.pedido.id,
            this.pedido.promissorias
          );
          this.$router.push("/faturamento");
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
